import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-header-form',
  templateUrl: './header-form.component.html',
  styleUrls: ['./header-form.component.scss']
})
export class HeaderFormComponent implements OnInit {

  @Input() title: string = "";
  @Input() subtitle: string = "";
  @Input() panelOpenState: boolean = false;

  @Input() canShowClearFilter = false;
  @Input() canShowPanelFilter = false;
  @Input() canCreateNewExcel = false;
  @Input() canImportExcel = false;
  @Input() canConfigure = false;
  @Input() canExportExcel = false;
  @Input() canCreateManualInvoice = false;

  @Output() onClearFilterEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() onPanelOpenStateEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onNewEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() onImportEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSettingsEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() onExportAsExcelEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCreateManualInvoiceEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }


  onClearFilters() {
    this.onClearFilterEvent.emit();
  }

  onShowFilter() {
    this.panelOpenState = !this.panelOpenState;
    this.onPanelOpenStateEvent.emit(this.panelOpenState);
  }

  onNew() {
    this.onNewEvent.emit();
  }

  onImport() {
    this.onImportEvent.emit();
  }

  onSettings() {
    this.onSettingsEvent.emit();
  }

  onExportAsExcel() {
    this.onExportAsExcelEvent.emit();
  }

  onCreateManualInvoice() {
    this.onCreateManualInvoiceEvent.emit();
  }
}
